import Promise from 'bluebird';
import config from '../../config';

class CastAPIManager {
  constructor() {
    this._promise = null;
  }

  init() {
    this._promise = this._promise || new Promise((resolve, reject) => {
      /* eslint-disable no-underscore-dangle */
      window.__onGCastApiAvailable = (isAvailable) => {
      /* eslint-enable no-underscore-dangle */
        if (isAvailable) {
          this._initializeCastApi();
          resolve();
        } else {
          reject(new Error('Chromecast API unavailable.'));
        }
      };

      setTimeout(reject, 1000, new Error('No chromecast capabilities?'));
    });

    return this._promise;
  }

  _initializeCastApi() {
    window.cast.framework.CastContext.getInstance().setOptions({
      receiverApplicationId: config.CHROMECAST_APP_ID,
      autoJoinPolicy: window.chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
      resumeSavedSession: true,
    });
  }
}

export default new CastAPIManager();



// WEBPACK FOOTER //
// ./src/services/chromecast/cast_api_manager.js